import React from "react";

// components

import CardDataTable from "components/cards/logistica/base/CardDataTable.js";
import CardVencidos from "components/cards/logistica/base/CardVencidos.js";


export default function Base() {
  const baseSelect = localStorage.getItem("baseSelected") || "";
  const cargoSelect = localStorage.getItem("cargo") || "";
  return (
    <>
      <div className="flex flex-wrap">

        <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-4">
          {cargoSelect === "ENTREGADOR" ? null : <CardVencidos baseSelect={baseSelect} />}

          <CardDataTable />

        </div>
      </div>

    </>
  );
}
